<template>
  <div>
    <v-card elevation="2" :loading="loading">
      <v-alert type="success" dismissible v-if="alerts.success.show">
        {{ alerts.success.message }}
      </v-alert>
      <v-alert type="error" dismissible v-if="alerts.error.show">
        {{ alerts.error.message }}
      </v-alert>
      <v-dialog
        v-model="displayFetchingDataDialog"
        hide-overlay
        persistent
        width="300"
      >
        <v-card color="primary" dark>
          <v-card-text>
            Fetching on chain data
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-row>
        <v-col cols="12" md="4" v-for="token in redTokens" :key="token.address">
          <v-card class="mx-auto" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline mb-4">
                  {{ token.symbol }}
                </div>
                <v-list-item-title class="text-h5 mb-1">
                  {{ token.name }}
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{ token.totalSupplyFmt }}
                </v-list-item-subtitle>
                <v-card-text>
                  <v-list-item>
                    <v-list-item-title>Total Burn</v-list-item-title>
                    <v-list-item-subtitle
                      >{{ token.totalBurnedFmt }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item v-if="token.holderInfo.isSet">
                    <v-list-item-title>My Balance</v-list-item-title>
                    <v-list-item-subtitle
                      >{{ token.holderInfo.balanceFmt }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-title>Burn</v-card-title>
                        <v-card-text>
                          <v-progress-circular
                            :rotate="360"
                            :size="100"
                            :width="15"
                            :value="token.percentageBurned"
                            color="teal"
                          >
                            <strong
                              >{{ Math.ceil(token.percentageBurned) }}%</strong
                            >
                          </v-progress-circular>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-title>Pancake</v-card-title>
                        <v-card-text>
                          <v-progress-circular
                            :rotate="360"
                            :size="100"
                            :width="15"
                            :value="token.percentageRouter"
                            color="deep-orange lighten-2"
                          >
                            <strong
                              >{{ Math.ceil(token.percentageRouter) }}%</strong
                            >
                          </v-progress-circular>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="BNB"
                        v-model="buyForm.amount"
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-btn block color="red" @click="directBuy(token)">
                        Buy
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-list-item-content>

              <v-list-item-avatar tile size="32">
                <v-img max-height="32" max-width="32" :src="token.img"></v-img>
              </v-list-item-avatar>
            </v-list-item>
            <v-card-actions>
              <v-btn class="mx-2" fab dark small @click="buy(token)">
                <v-icon dark> mdi-currency-usd-circle</v-icon>
              </v-btn>
              <v-btn class="mx-2" fab dark small @click="charts(token)">
                <v-icon dark> mdi-chart-line</v-icon>
              </v-btn>
              <v-btn class="mx-2" fab dark small @click="website(token)">
                <v-icon dark> mdi-web</v-icon>
              </v-btn>
              <v-btn class="mx-2" fab dark small @click="twitter(token)">
                <v-icon dark> mdi-twitter</v-icon>
              </v-btn>
              <v-btn class="mx-2" fab dark small @click="telegram(token)">
                <v-icon dark> mdi-telegram</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { truncateEthAddress } from "../services/utils";
import { ethers } from "ethers";
export default {
  name: "TokenList",
  data: () => ({
    loading: false,
    fetchingDataCompleted: false,
    buyForm: {
      amount: 0,
    },
    alerts: {
      success: {
        show: false,
        message: "",
      },
      error: {
        show: false,
        message: "",
      },
    },
    redTokens: null,
  }),
  methods: {
    async loadData() {
      this.fetchingDataCompleted = false;
      this.redTokens = this.tokens;
      this.fetchingDataCompleted = true;
    },
    directBuy(token) {
      const amountBuy = ethers.utils.parseUnits(this.buyForm.amount, "ether");
      const router = token.router;
      console.log(token.address);
      console.log(token.weth);
      console.log(amountBuy);
      router.methods
        .swapExactETHForTokens(
          0,
          [token.weth, token.address],
          window.ethereum.selectedAddress,
          Date.now() + 1000 * 60 * 20 //20 minutes
        )
        .send({
          from: window.ethereum.selectedAddress,
          value: amountBuy,
        })
        .on("receipt", this.onContractReceipt)
        .on("error", this.onContractError);
    },
    onContractReceipt(receipt) {
      console.log("onReleaseReceipt: ", receipt);
      this.stopLoading();
      this.showSuccess("Transaction executed.");
    },
    onContractError(error) {
      console.error("onReleaseReceipt: ", error);
      this.stopLoading();
      this.showError("Cannot execute transaction, see logs for more.");
    },
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
    showSuccess(message) {
      this.alerts.success.message = message;
      this.alerts.success.show = true;
    },
    showError(message) {
      this.alerts.error.message = message;
      this.alerts.error.show = true;
    },
    openAddressInExplorer(address) {
      window.open(
        `${this.globalConfig.explorerRootURL}/address/${address}`,
        "_blank"
      );
    },
    shortAddress(addr) {
      return truncateEthAddress(addr);
    },
    tokenImgSrc(address) {
      return require(`../assets/tokens/${address}.png`);
    },
    buy(token) {
      window.open(token.buyLink, "_blank");
    },
    website(token) {
      window.open(token.website, "_blank");
    },
    telegram(token) {
      window.open(token.telegram, "_blank");
    },
    charts(token) {
      window.open(token.charts, "_blank");
    },
    twitter(token) {
      window.open(token.twitter, "_blank");
    },
  },
  async mounted() {
    await this.loadData();
  },
  computed: {
    displayFetchingDataDialog() {
      return !this.fetchingDataCompleted;
    },
    ...mapState(["web3", "globalConfig", "tokens"]),
  },
};
/*function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}*/
</script>

<style scoped></style>
